// eslint-disable-next-line
import {injectable} from "inversify";
import {rootContainer, TYPE} from "../container/root";
import {IApiResponse, IHttpService} from "../http-service";
import { ICalculatorRequestDTO, ICalculatorResponseDTO, IRefundRequestDto } from "../../pages/manage-returns/rma-page/components/refund-calculator-drawer/refund-calculator-types";
import { IRmaData } from "../../pages/manage-returns/rma-page/rma-types";


@injectable()
class RefundCalculatorService {
	private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);
	
	public async fetchCalculatorData(dto: ICalculatorRequestDTO, rmaId: number): Promise<ICalculatorResponseDTO> {
		const res = await this.httpService.post<IApiResponse<ICalculatorResponseDTO>>(`/rms-api/manage-returns/rma/${rmaId}/fetch-refund-calculator`, dto);
		return res.payload;
	}

	public async refund(dto: IRefundRequestDto, rmaId: number): Promise<IRmaData> {
		const res = await this.httpService.post<IApiResponse<IRmaData>>(`/rms-api/manage-returns/rma/${rmaId}/refund`, dto);
        return res.payload;
	}
	
}


export default RefundCalculatorService;
